var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"main-app"}},[_c('auth-header'),_c('v-main',{attrs:{"id":"content-wrapper"}},[_c('v-container',{staticClass:"main-container main-container--auth",class:{
        'main-container--center' : _vm.$route.name === 'login',
        'barcode-layout': _vm.$route.name === 'order-barcode'
      },attrs:{"fluid":""}},[(_vm.$route.meta.keep_alive)?_c('KeepAlive',[_c('router-view',{key:_vm.$route.fullPath})],1):_c('router-view',{key:_vm.$route.fullPath})],1)],1),_c('user-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }